export enum LayoutType {
  Sidebar,
  Topbar
}
